/**
 * Collection Schema
 * Injects Google ItemList structured data from the first Tagalys results response
 */

class CollectionSchema {
  constructor () {
    this.eventBus = window.theme.tagalys.results.eventBus

    this._boundHandlers = {
      handleProductsUpdated: products => this.handleProductsUpdated(products),
    }

    this.subscribeToEvents()
  }

  subscribeToEvents () {
    this.eventBus.subscribe(
      'results:state:products:updated',
      this._boundHandlers.handleProductsUpdated,
    )
  }

  unsubscribeFromEvents () {
    this.eventBus.unsubscribe(
      'results:state:products:updated',
      this._boundHandlers.handleProductsUpdated,
    )
  }

  handleProductsUpdated (products) {
    this.unsubscribeFromEvents()
    this.injectItemListSchema(products)
  }

  injectItemListSchema (products) {
    if (!products || !products.length) return

    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.textContent = JSON.stringify({
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: products.map((product, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: product.title,
        url: `${window.location.origin}/products/${product.handle}`,
      })),
    })

    document.head.appendChild(script)
  }
}

window.theme.tagalys.results.collectionSchema = new CollectionSchema()
